import { Route } from '@angular/router';
import { authenticatedGuard } from '../../subscription/guards/authenticated.guard';
import { studentGuard } from '../../subscription/guards/student.guard';

export const studentRoutes: Route[] = [
  {
    path: 'student',
    loadComponent: () =>
      import('./student-layout/student-layout.component').then(
        (m) => m.StudentLayoutComponent
      ),
    canActivate: [authenticatedGuard, studentGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./student-dashboard/student-dashboard.component').then(
            (m) => m.StudentDashboardComponent
          ),
      },
      {
        path: 'class/:classId',
        loadComponent: () =>
          import('./student-class-view/student-class-view.component').then(
            (m) => m.StudentClassViewComponent
          ),
      },
      {
        path: 'settings',
        loadComponent: () =>
          import('./student-settings/student-settings.component').then(
            (m) => m.StudentSettingsComponent
          ),
      },
    ],
  },
];
